if (!customElements.get("delivery-info")) {
  class DeliveryInfo extends HTMLElement {
    static WEEKDAYS = [
      "neděle",
      "pondělí",
      "úterý",
      "středa",
      "čtvrtek",
      "pátek",
      "sobota",
    ];

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
      if (!this.hasAttribute("data-manual-date")) this.renderDeliveryDate();

      this.thresholdCents = Number(this.dataset.thresholdCents) || 0;
      if (this.thresholdCents > 0 && window.FoxTheme?.pubsub) {
        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
          (event) => {
            const cart = event?.cart;
            if (!cart) return;
            this.updateProgress(cart.items_subtotal_price ?? cart.total_price ?? 0);
          }
        );
      }
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    }

    // Today + N working days, skipping weekends and the configured holidays ("24.12.,25.12.").
    renderDeliveryDate() {
      const target = this.querySelector("[data-delivery-date]");
      if (!target) return;

      const workingDays = Number(this.dataset.workingDays) || 0;
      const holidays = (this.dataset.holidays || "")
        .split(",")
        .map((day) => day.trim())
        .filter(Boolean);
      const date = new Date();
      let added = 0;

      for (let i = 0; i < 30 && added < workingDays; i++) {
        date.setDate(date.getDate() + 1);
        const weekday = date.getDay();
        const key = `${date.getDate()}.${date.getMonth() + 1}.`;
        if (weekday !== 0 && weekday !== 6 && !holidays.includes(key)) added++;
      }

      target.textContent = `${DeliveryInfo.WEEKDAYS[date.getDay()]} ${date.getDate()}. ${date.getMonth() + 1}.`;
    }

    updateProgress(cartTotalCents) {
      const rate = Number(window.Shopify?.currency?.rate || 1);
      const threshold = Math.round(this.thresholdCents * rate);
      const remaining = Math.max(threshold - cartTotalCents, 0);
      const percent = Math.min(Math.round((cartTotalCents / threshold) * 100), 100);

      const remainingRow = this.querySelector("[data-progress-remaining]");
      const success = this.querySelector("[data-progress-success]");
      const amount = this.querySelector("[data-remaining-amount]");
      const fill = this.querySelector("[data-progress-fill]");

      if (amount) {
        amount.textContent = FoxTheme.Currency.formatMoney(
          remaining,
          FoxTheme.settings?.moneyFormat
        );
      }
      if (remainingRow) remainingRow.hidden = remaining === 0;
      if (success) success.hidden = remaining > 0;
      if (fill) {
        fill.style.width = `${percent}%`;
        fill.parentElement.setAttribute("aria-valuenow", percent);
      }
    }
  }

  customElements.define("delivery-info", DeliveryInfo);
}
